/* eslint-disable */
export default [{
    title: 'Projects',
    route: 'Projects',
    icon: 'GridIcon',
    userview: true,
},{
    title: 'Users',
    route: 'Users',
    icon: 'UsersIcon',
    userview: false,
}

]



/*

{
    title: 'Dashboard',
    route: 'Home',
    icon: 'MonitorIcon',
},
3.1 --> Main Stitching

task_data['scene_path'] = '/run/user/1000/gvfs/smb-share:server=nas1dd22f.local,share=home/MILAN/data/MaxDani_Val_GBM_process_scenes'
task_data['output_path'] = '/run/user/1000/gvfs/smb-share:server=nas1dd22f.local,share=home/MILAN/data/MaxDani_Val_GBM_process_stitching'
task_data['cores'] = 5
task_data['continue_calculation'] = True
task_data['clean_after'] = True

3.2 --> extract  Stitching outputs
task_data['output_path'] = '/run/user/1000/gvfs/smb-share:server=nas1dd22f.local,share=home/MILAN/data/MaxDani_Val_GBM_process_stitching'

3.3 --> Remove check images
task_data['output_path'] = '/run/user/1000/gvfs/smb-share:server=nas1dd22f.local,share=home/MILAN/data/MaxDani_Val_GBM_process_stitching'

3.4 --> Lumping images after stitching

task_data['tiles_coor_file'] = '/run/user/1000/gvfs/smb-share:server=nas1dd22f.local,share=home/MILAN/data/MaxDani_Val_GBM_process_stitching/final/df_tiles_coor.csv'
task_data['MOI_file'] = '/run/user/1000/gvfs/smb-share:server=nas1dd22f.local,share=home/MILAN/data/MaxDani_Val_GBM_process_stitching/final/df_MOI.csv'
task_data['fig_input_folder'] = '/run/user/1000/gvfs/smb-share:server=nas1dd22f.local,share=home/MILAN/data/MaxDani_Val_GBM_process_02/RAW'
task_data['fig_output_file'] = '/run/user/1000/gvfs/smb-share:server=nas1dd22f.local,share=home/MILAN/data/MaxDani_Val_GBM_process_stitching/lumped'
task_data['continue_calculation'] = True
task_data['clean_after'] = True

3.5 --> clean everything but final csvs
task_data['output_path'] = '/run/user/1000/gvfs/smb-share:server=nas1dd22f.local,share=home/MILAN/data/MaxDani_Val_GBM_process_stitching'
*/